import { getSeoName } from 'utils/tokenize';

export type ResponseOfferPremiseData = {
	description: string;
	emails: {
		default: boolean;
		email: string;
		id: number;
		name: string;
	}[];
	external_id: number;
	id: number;
	locality: {
		address: string;
		address_id: number;
		citypart: string;
		country_id: number;
		district: string;
		district_id: number;
		district_seo_name: string;
		entity_id: number;
		entity_type: string;
		gps_lat: number;
		gps_lon: number;
		housenumber: string;
		municipality: string;
		municipality_id: number;
		municipality_seo_name: string;
		quarter: string;
		quarter_id: number;
		region: string;
		region_id: number;
		region_seo_name: string;
		source: string;
		street: string;
		street_id: number;
		streetnumber: string;
		ward: string;
		ward_id: number;
		zip: string;
	};
	logo: string;
	name: string;
	old_id: number;
	opening_hours: {
		opening_time_additional_info: string;
		opening_time_description: string;
		opening_time_holiday_info: string;
		opening_time_st: {
			day: number;
			from: string;
			to: string;
		}[];
		opening_time_visible: boolean;
	};
	phones: {
		default: boolean;
		id: number;
		name: string;
		phone: string;
	}[];
	seo_name: string;
	subject: { ico: number; id: number };
	url_detail_firmy: string;
	use_advert_locality: boolean;
	web: string;
};

export type PremiseData = {
	description: string;
	emails: {
		default: boolean;
		email: string;
		id: number;
		name: string;
	}[];
	externalId: number;
	id: number;
	locality?: {
		address: string;
		addressId: number;
		citypart: string;
		countryId: number;
		district: string;
		districtId: number;
		districtSeoName: string;
		entityId: number;
		entityType: string;
		gpsLat: number;
		gpsLon: number;
		housenumber: string;
		municipality: string;
		municipalityId: number;
		municipalitySeoName: string;
		quarter: string;
		quarterId: number;
		quarterSeoName: string;
		region: string;
		regionId: number;
		regionSeoName: string;
		source: string;
		street: string;
		streetId: number;
		streetnumber: string;
		ward: string;
		wardId: number;
		wardSeoName: string;
		zip: string;
	};
	logo: string;
	name: string;
	oldId: number;
	openingHours?: {
		openingTimeAdditionalInfo: string;
		openingTimeDescription: string;
		openingTimeHolidayInfo: string;
		openingTimeSt: {
			day: number;
			from: string;
			to: string;
		}[];
		openingTimeVisible: boolean;
	};
	phones: {
		default: boolean;
		id: number;
		name: string;
		phone: string;
	}[];
	seoName: string;
	subject: { ico: number; id: number };
	urlDetailFirmy: string;
	useAdvertLocality: boolean;
	web: string;
	isPremise: true;
};

export function normalizeOfferPremiseData(premise: ResponseOfferPremiseData): PremiseData {
	return {
		externalId: premise.external_id,
		id: premise.id,
		name: premise.name,
		description: premise.description,
		logo: premise.logo,
		emails: premise.emails,
		phones: premise.phones,
		locality: premise.locality && {
			address: premise.locality.address,
			addressId: premise.locality.address_id,
			citypart: premise.locality.citypart,
			countryId: premise.locality.country_id,
			district: premise.locality.district,
			districtId: premise.locality.district_id,
			districtSeoName: premise.locality.district_seo_name,
			entityId: premise.locality.entity_id,
			entityType: premise.locality.entity_type,
			gpsLat: premise.locality.gps_lat,
			gpsLon: premise.locality.gps_lon,
			housenumber: premise.locality.housenumber,
			municipality: premise.locality.municipality,
			municipalityId: premise.locality.municipality_id,
			municipalitySeoName: premise.locality.municipality_seo_name,
			quarter: premise.locality.quarter,
			quarterId: premise.locality.quarter_id,
			quarterSeoName: getSeoName(premise.locality.quarter),
			region: premise.locality.region,
			regionId: premise.locality.region_id,
			regionSeoName: premise.locality.region_seo_name,
			source: premise.locality.source,
			street: premise.locality.street,
			streetId: premise.locality.street_id,
			streetnumber: premise.locality.streetnumber,
			ward: premise.locality.ward,
			wardId: premise.locality.ward_id,
			wardSeoName: getSeoName(premise.locality.ward),
			zip: premise.locality.zip,
		},
		openingHours: premise.opening_hours && {
			openingTimeAdditionalInfo: premise.opening_hours.opening_time_additional_info,
			openingTimeDescription: premise.opening_hours.opening_time_description,
			openingTimeHolidayInfo: premise.opening_hours.opening_time_holiday_info,
			openingTimeSt: premise.opening_hours.opening_time_st,
			openingTimeVisible: premise.opening_hours.opening_time_visible,
		},
		subject: premise.subject,
		seoName: premise.seo_name,
		urlDetailFirmy: premise.url_detail_firmy,
		useAdvertLocality: premise.use_advert_locality,
		web: premise.web,
		oldId: premise.old_id,
		isPremise: true,
	};
}
